export default __webpack_public_path__ + "static/media/maraba-terminal.ba7a2f50.png";